
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company/legal",
      function () {
        return require("private-next-pages/company/legal.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/company/legal"])
      });
    }
  